export const generateCandidateFeedbackLink = (spotId: string) => {
  const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLSfPudWbK0ETc4Ge8bG7i-cXvpDnJLBnKq4Gi_YT4TU-RzfIWQ/viewform?usp=pp_url";
  return `${baseUrl}&entry.1122305251=${spotId}`;
};
